import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import { RefundInterface } from '../../store/callrecorder/refundsSlice';

const PREFIX = 'callrecorder';

// No processStrategy/url — refunds are list-only, there is no Show page.
export const refundsEntity = new schema.Entity('refunds');

const fetchRefundsCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      refunds: { [key: string]: RefundInterface };
    }
  >(response.data.refunds, [refundsEntity]);

  return {
    refunds: normalized.entities?.refunds || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchRefunds = createAsyncThunk(
  `${PREFIX}_refunds/fetchRefunds`,
  async (params: object = {}) => fetchRefundsCollection('/onesky/refunds', params)
);
